export function isMaskedValue(value: string): boolean {
  return value.includes('*');
}
